import React, { useEffect } from 'react'
import { View, Image, StatusBar, SafeAreaView, TouchableOpacity, ScrollView } from 'react-native'
import { useSelector } from 'react-redux'
import { dv_app_logo } from '../assets'
import { Form, Label } from '../components/SharedComponents'
import { colors, global } from '../utils'
import localize from '../shared/localize'
import { PrimaryTitle } from '../shared/components/labels'

function GetStarted (props) {
  const isLogin = useSelector(({ auth }) => auth.isLogin)

  useEffect(() => {
    if (!global.isNative) {
      window.document.title = localize.Daily_Vitals_powered_by_Woogi
      if (isLogin) _navigate('dashboard')
    }
  }, [])

  const _navigate = (pathname, state, search) => {
    if (!global.isNative) {
      return props.history.push({
        pathname: '/' + pathname,
        state,
        search
      })
    }
    return props.navigation.navigate(pathname, state)
  }

  const _term = () => {
    if (global.isNative) return _navigate('TermsOfUse')
    return window.open(global.termUrl, '_blank')
  }

  const _policy = () => {
    if (global.isNative) return _navigate('PrivacyPolicy')
    return window.open(global.privacyUrl, '_blank')
  }

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <StatusBar barStyle='dark-content' backgroundColor={colors.app_background} />
      <ScrollView
        contentContainerStyle={{ flexGrow: 1 }}
      >
        <View style={{ flex: 10, alignItems: 'center', justifyContent: 'center' }}>
          <Image
            source={dv_app_logo}
            style={{ width: 200, height: 200 }}
            resizeMode='contain'
          />
        </View>

        <View style={{ marginHorizontal: 20, marginBottom: 20 }}>
          <PrimaryTitle
            align='center'
          >
            {`Our kids and Families are in an Education and Mental Well-Being Crisis...${'\n\r'}These are Really Tough Times.${'\n\r'}Parents Need to Take Control (no one else is) and Help our Kids Learn how to be Resilient and Armed with the Life-Skills to Succeed in this New World.${'\n\r'}Our Kids Can Emerge from this Crisis either Better or Worse – it’s Up to Us.
            `}
          </PrimaryTitle>
        </View>

        <View style={{ paddingHorizontal: 40, width: '100%', flex: 10 }}>

          <View style={{ flex: 1 }}>
            <Form.Button
              title='GET STARTED'
              onPress={() => _navigate('Welcome')}
            />
            <View style={{ marginVertical: 20, alignItems: 'center' }}>
              <Label.PrimaryCaption>
                {localize.OR}
              </Label.PrimaryCaption>
            </View>
            <Form.Button
              title={localize.SIGN_IN}
              variant='outline'
              onPress={() => _navigate('SignIn')}
            />
          </View>

          <View style={{ flexDirection: 'row', justifyContent: 'center', marginVertical: 30 }}>
            <TouchableOpacity
              onPress={_term}
            >
              <Label.LinkIndigo>
                {localize.Terms_of_Use}
              </Label.LinkIndigo>
            </TouchableOpacity>
            <View style={{ marginHorizontal: 15, backgroundColor: colors.indigo, width: 1 }} />
            <TouchableOpacity
              onPress={_policy}
            >
              <Label.LinkIndigo>
                {localize.Privacy_Policy}
              </Label.LinkIndigo>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  )
}

export default GetStarted
